/** * @file * Youtube Video. * * Vue component that displays an inline Youtube
video. * See README.md for full details. */

<template>
  <div>
    <youtube
      ref="youtube"
      :video-id="videoData.id"
      :player-vars="playerVars"
      @ready="onReady"
      width="100%"
      height="100%"
    />
  </div>
</template>

<script lang="js">
import { Youtube } from 'vue-youtube';

export default {
  name: 'ahc-video-youtube',
  components: {
    Youtube,
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    isPlaying: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // Define any object defaults we want to overwrite at the property level.
    const defaults = {
      defaultVideoData: {
        options: {
          autoplay: 0,
          playsinline: 0
        },
      },
    };

    return {
      // Overwrite the defaults with any property values passed in.
      videoData: Object.assign({}, defaults.defaultVideoData, this.video),
    };
  },
  watch: {
    // watch for a change to the 'isPlaying' prop from the parent (video.vue)
    isPlaying(playing) {
      if(playing) {
        this.$refs.youtube.player.playVideo();
      } else {
        this.$refs.youtube.player.pauseVideo();
        this.$refs.youtube.player.seekTo(0);
      }
    }
  },
  computed: {
    /**
     * Returns the Youtube player object.
     *
     * @returns {Object}
     */
    player() {
      return this.$refs.youtube.player;
    },
    /**
     * Returns the playervars that will alter the iframe behavior.
     *
     * @returns {{rel: number, autoplay: number}}
     */
    playerVars() {
      return {
        autoplay: this.videoData.options.autoplay,
        playsinline: this.videoData.options.playsinline,
        rel: 0,
      };
    },
  },
  methods: {
    onReady() {
      this.$emit('playerReady');
    },
  },
};
</script>
